export default "__VITE_ASSET__2s9fHcaK__"